export default __webpack_public_path__ + "static/media/logo.e385bb68.png";